import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { impersonation } from '../api/methods';
export const impersonationKeys = {
    active: ['impersonation', 'active'],
};
/**
 * Query the admin's active impersonation session (if any).
 * Used to rehydrate the banner after a page reload.
 */
export function useActiveImpersonation(enabled) {
    return useQuery({
        queryKey: impersonationKeys.active,
        queryFn: () => impersonation.active(),
        enabled,
        staleTime: 30 * 1000,
        retry: false,
    });
}
export function useStartImpersonation() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ targetUserId, reason, ttlMinutes }) => impersonation.start(targetUserId, reason, ttlMinutes),
        onSuccess: () => {
            // Invalidate everything — we are now acting as a different user and
            // every cached response is for the old identity.
            queryClient.clear();
        },
    });
}
export function useStopImpersonation() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: () => impersonation.stop(),
        onSuccess: () => {
            queryClient.clear();
        },
    });
}
//# sourceMappingURL=useImpersonation.js.map